jQuery(function($) {
    $(document).ready(function() {
        
        var $languageButtonGroups = $('.resource-links-group');
        var $resourceViewerElements = $('.resource-viewer');

        // Function to load PDF via PDF.js using AJAX if the viewer is set to PDF
        function loadPdfIfNeeded() {
            var $viewer = $('.resource-viewer.active');
            if ($viewer.hasClass('pdf')) {
                // var pdfHref = $viewer.prev().find('[href]').attr('href');
                var pdfHref = $viewer.data('pdf-url');
                if (pdfHref) {
                    $.ajax({
                        url: PifSingleResourceConfig.ajax_url,
                        method: 'POST',
                        data: {
                            action: PifSingleResourceConfig.ajax_action,
                            url: pdfHref
                        },
                        success: function(response) {
                            // Handle the response
                            $viewer.html(response.pdf_viewer_output);
                        },
                            error: function(xhr) {
                            console.error('Failed to load PDF:', xhr);
                        }
                    });
                }
            }
        }

        // Attempt to fetch PDF on page load
        loadPdfIfNeeded();

        // Handle loading spinner display for iframes
        function addSpinner(wrapper) {
            if (!wrapper.querySelector('.iframe-spinner')) {
                const spinner = document.createElement('div');
                spinner.className = 'iframe-spinner';
                spinner.innerHTML = '<div class="spinner-border text-primary" role="status" style="width:2rem;height:2rem;"><span class="visually-hidden">Loading...</span></div>';
                wrapper.appendChild(spinner);
            }
        }
        function showSpinner(wrapper) {
            const spinner = wrapper.querySelector('.iframe-spinner');
            if (spinner) spinner.style.display = 'flex';
        }
        function hideSpinner(wrapper) {
            const spinner = wrapper.querySelector('.iframe-spinner');
            if (spinner) spinner.style.display = 'none';
        }
        function handleIframeLoading(wrapper) {
            const iframe = wrapper.querySelector('iframe');
            if (!iframe) return;
            addSpinner(wrapper);
            // hideSpinner(wrapper); // Hide spinner initially

            let lastHeight = iframe.clientHeight;
            let spinnerShown = false;
            let observer = new ResizeObserver(entries => {
                for (let entry of entries) {
                    let newHeight = entry.target.clientHeight;
                    // If iframe shrinks significantly, show spinner
                    if (!spinnerShown && newHeight < lastHeight - 10) {
                        showSpinner(wrapper);
                        spinnerShown = true;
                    }
                    // If iframe grows significantly, hide spinner
                    if (spinnerShown && newHeight > lastHeight + 10) {
                        hideSpinner(wrapper);
                        spinnerShown = false;
                    }
                    lastHeight = newHeight;
                }
            });
            observer.observe(iframe);

            // Fallback: hide spinner after 7 seconds
            // const timeoutId = setTimeout(function() {
            //     hideSpinner(wrapper);
            //     observer.disconnect();
            // }, 7000);

            // Also hide spinner on load event (for browsers that support it)
            iframe.addEventListener('load', function onLoad() {
                hideSpinner(wrapper);
                observer.disconnect();
                // clearTimeout(timeoutId);
                iframe.removeEventListener('load', onLoad);
            });

        }

        // Initial load: setup spinner for all visible .iframe-wrapper
        document.querySelectorAll('.resource-viewer.active .iframe-wrapper').forEach(handleIframeLoading);

        var $langOptions = $('#resource-language-selector .dropdown-menu a');

        // Handle language selection clicks
        $langOptions.on('click', function(e) {
            e.preventDefault();

            var selectedLang = $(this).attr('lang-code'); // Get the selected language code
            $('.resource-language__current-language').text($(this).text()); // Update dropdown button language name

            // Update URL parameter
            var url = new URL(window.location.href);
            if (selectedLang !== 'en') {
                url.searchParams.set('ver', selectedLang);
            } else {
                url.searchParams.delete('ver');
            }
            history.replaceState(null, '', url.toString());

            // push language selection event to GA4 for analytics
            gtag('event', 'resource_language_view', {
                resource_slug: getResourceSlug(),
                resource_language: selectedLang,
                language_trigger: 'dropdown'
            });

            setTimeout(function () {
                // Wait for DOM update after language switch to reapply iframe spinner functions
                document.querySelectorAll('.resource-viewer.active .iframe-wrapper').forEach(handleIframeLoading);
            }, 50);
            
            $languageButtonGroups.addClass('d-none'); // Hide all groups
            $resourceViewerElements.removeClass('active'); // Remove active class from all viewers
            
            // Show the selected group
            var $selectedGroup = $('.resource-links-group[data-lang="' + selectedLang + '"]');
            $selectedGroup.removeClass('d-none');

            // If the viewer in the selected group is a PDF, reload it
            var $viewer = $selectedGroup.find('.resource-viewer');
            $viewer.addClass('active'); // Add active class to the current viewer
            if ($viewer.hasClass('pdf')) {
                loadPdfIfNeeded();
            }
        });

        // Analytics: Determine resource language and slug for dataLayer
        function getResourceLanguage() {
            const path = window.location.pathname;
            const params = new URLSearchParams(window.location.search);

            // Check query param pattern: ?ver=es
            const ver = params.get('ver');
            if (ver) {
                return { language: ver, trigger: 'query_param' };
            }

            // Check subdirectory pattern: /es/resources/...
            const subdirMatch = path.match(/^\/([a-z]{2})\//);
            if (subdirMatch) {
                return { language: subdirMatch[1], trigger: 'subdirectory' };
            }

            // Default: English
            return { language: 'en', trigger: 'default' };
        }

        function getResourceSlug() {
            // Strip language prefix and trailing slash, take last path segment
            return window.location.pathname
                .replace(/^\/[a-z]{2}\//, '/')
                .split('/')
                .filter(Boolean)
                .pop();
        }

        // Fire on page load and push to GA4
        const lang = getResourceLanguage();
        gtag('event', 'resource_language_view', {
            resource_slug: getResourceSlug(),
            resource_language: lang.language,
            language_trigger: lang.trigger
        });
        
    });
});